"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Select = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Select"));

var _Checkbox = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Checkbox"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Form = function Form(_ref) {
  var _onChange = _ref.onChange,
      _ref$state = _ref.state,
      _ref$state$containerS = _ref$state.containerSize,
      containerSize = _ref$state$containerS === void 0 ? 'full' : _ref$state$containerS,
      _ref$state$containerT = _ref$state.containerType,
      containerType = _ref$state$containerT === void 0 ? 'fluid' : _ref$state$containerT,
      _ref$state$aspectRati = _ref$state.aspectRatio,
      aspectRatio = _ref$state$aspectRati === void 0 ? '' : _ref$state$aspectRati,
      _ref$state$alignConte = _ref$state.alignContent,
      alignContent = _ref$state$alignConte === void 0 ? 'center' : _ref$state$alignConte,
      matchContentHeight = _ref$state.matchContentHeight,
      mobileTwoColumnLayout = _ref$state.mobileTwoColumnLayout;
  var containerSizeOptions = [{
    label: 'Full Width',
    value: 'full'
  }, {
    label: 'Wide',
    value: 'wide'
  }, {
    label: 'Standard',
    value: 'standard'
  }, {
    label: 'Narrow',
    value: 'narrow'
  }];
  var containerTypeOptions = [{
    label: 'Fluid',
    value: 'fluid'
  }, {
    label: 'Fixed',
    value: 'fixed'
  }];
  var aspectRatioOptions = [{
    label: 'Dynamic',
    value: ''
  }, {
    label: '1:1',
    value: '1:1'
  }, {
    label: '16:9',
    value: '16:9'
  }, {
    label: '4:3',
    value: '4:3'
  }, {
    label: '2:1',
    value: '2:1'
  }];
  var alignmentOptions = [{
    label: 'Top',
    value: 'flex-start'
  }, {
    label: 'Centre',
    value: 'center'
  }, {
    label: 'Bottom',
    value: 'flex-end'
  }];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Container Size",
    value: containerSize,
    onChange: function onChange(e) {
      return _onChange({
        containerSize: e.value
      });
    },
    options: containerSizeOptions
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Container Type",
    value: containerType,
    onChange: function onChange(e) {
      return _onChange({
        containerType: e.value
      });
    },
    options: containerTypeOptions
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Container Aspect Ratio",
    value: aspectRatio,
    onChange: function onChange(e) {
      return _onChange({
        aspectRatio: e.value
      });
    },
    options: aspectRatioOptions
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Vertically Align Content",
    value: alignContent,
    onChange: function onChange(e) {
      return _onChange({
        alignContent: e.value
      });
    },
    options: alignmentOptions
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "Match Content Height",
    checked: matchContentHeight,
    onChange: function onChange(e) {
      return _onChange({
        matchContentHeight: e.target.checked
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "Two Column Layout on Mobile",
    checked: mobileTwoColumnLayout,
    onChange: function onChange(e) {
      return _onChange({
        mobileTwoColumnLayout: e.target.checked
      });
    }
  }));
};

var _default = Form;
exports["default"] = _default;